import Comment from './Comment/Comment'

export { Comment }
